/* eslint-disable react/require-default-props */
import React from 'react';
import PasswordResetForm from './authentication/PasswordResetForm';
import AuthCardLayout from './authentication/AuthCardLayout';

function PasswordReset() {
  return (
    <AuthCardLayout>
      <h3>Встановити пароль</h3>
      <PasswordResetForm
        layout="card"
        hasLabel
      />
    </AuthCardLayout>
  );
}

export default PasswordReset;
